var exports = {
  "kL": "x4ddf2309--52c5b7--container",
  "Sl": "x4ddf2309--52c5b7--image",
  "h_": "x4ddf2309--52c5b7--description",
};

module.exports = exports;
